import { SxProps, Theme } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';

import { Link } from './Link';

interface LinkItem {
    display: string;
    active?: boolean;
    to?: string;
}

export interface BreadcrumbProps {
    sx?: SxProps<Theme>;
    items: LinkItem[];
}

export function Breadcrumbs({ items, sx }: BreadcrumbProps) {
    return (
        <MuiBreadcrumbs sx={sx}>
            {items.map(item => {
                if (item.active) {
                    return (
                        <Typography key={item.display} color="primary">
                            {item.display}
                        </Typography>
                    );
                }

                return (
                    <Link key={item.display} color="inherit" to={item.to || ''}>
                        {item.display}
                    </Link>
                );
            })}
        </MuiBreadcrumbs>
    );
}
